import { useFlags } from 'launchdarkly-react-client-sdk';
import { Table, Code } from '@mantine/core';

export default function FeatureFlagsTab() {
  const flags = useFlags();

  const rows = Object.entries(flags).map(([key, value]) => (
    <Table.Tr key={key}>
      <Table.Td>
        <Code>{key}</Code>
      </Table.Td>
      <Table.Td>
        <Code>{String(value)}</Code>
      </Table.Td>
    </Table.Tr>
  ));

  return (
    <Table>
      <Table.Thead>
        <Table.Tr>
          <Table.Th>Flag Name</Table.Th>
          <Table.Th>Value</Table.Th>
        </Table.Tr>
      </Table.Thead>
      <Table.Tbody>{rows}</Table.Tbody>
    </Table>
  );
}
